import { render } from "./LeaveBalanceInsufficientModal.vue?vue&type=template&id=4c5cdd43&scoped=true"
import script from "./LeaveBalanceInsufficientModal.vue?vue&type=script&lang=js"
export * from "./LeaveBalanceInsufficientModal.vue?vue&type=script&lang=js"

import "./leave-balance-modal.scss?vue&type=style&index=0&id=4c5cdd43&lang=scss&scoped=true"

import exportComponent from "D:\\fz\\1_Task\\hr.haite.sg\\orangehrm-5.2\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c5cdd43"]])

export default __exports__